import type { SessionSummary } from '@sbc/domain-models/agents';

export type SessionTreeNode = SessionSummary & { children: SessionTreeNode[] };

// Assembles the flat, root-closed session page into a forest: every non-root item's
// originSessionId points at another item in the same payload, so each lands under its
// parent. Within-level order follows input order (createdAt desc from the API). An item
// whose parent is absent (shouldn't happen with a closed payload) is kept as a root.
export function buildTree(items: SessionSummary[]): SessionTreeNode[] {
  const nodes = new Map<string, SessionTreeNode>();
  for (const item of items) {
    nodes.set(item.id, { ...item, children: [] });
  }

  const roots: SessionTreeNode[] = [];
  for (const node of nodes.values()) {
    const parent = node.originSessionId ? nodes.get(node.originSessionId) : undefined;
    if (parent) {
      parent.children.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
}
